import loadable from '@loadable/component'
import Loading from 'components/Loading/Loading'
import { timeout } from 'promise-timeout'
import React from 'react'
import { TIMEOUT_LOADER } from 'utils/globals'

const ProposalDetailsECPF = loadable(
  () => timeout(import(
    /* webpackChunkName: "ProposalECPF" */
    'ecpf/app/ProposalECPF/views/ProposalDetailsECPF/ProposalDetailsECPF'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

const ProposalFlowECPF = loadable(
  () => timeout(import(
    /* webpackChunkName: "ProposalECPF" */
    'ecpf/app/ProposalECPF/views/ProposalFlowECPF/ProposalFlowECPF'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

const ProposalsListECPF = loadable(
  () => timeout(import(
    /* webpackChunkName: "ProposalECPF" */
    'ecpf/app/ProposalECPF/views/ProposalsListECPF/ProposalsListECPF'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

export { ProposalDetailsECPF, ProposalFlowECPF, ProposalsListECPF }
